import { render } from "./Tabs.vue?vue&type=template&id=63906df3&ts=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=63906df3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__